import { graphql, useStaticQuery } from "gatsby";
import { Category } from "../../constants/categories.constants";
import { Sector } from "../../constants/sectors.constants";
import { ImageWithMetaInfo, ProjectMetaInfo, ProjectMetaInfoWithQueriedResources } from "../../types/app.types";
import { MjHudsonBridgeImagesQuery } from "../../types/generated";

export const ProjectMetaInfoCarraighill: ProjectMetaInfo = {
  name: "carraighill",
  displayName: "Carraighill",
  abbreviation: "Carraighill",
  subtitle: "International Financial Research Provider",
  description: "Carraighill is an independent research provider focusing on financial systems and select equities. We designed and developed their website, which also features a members area for secure access of financial reports, and a comprehensive administration backend for the content managers.",
  url: 'https://carraighill.com/',
  categories: [
    Category.websites,
  ],
  sectors: [
    Sector.finance,
  ],
  hasPage: false,
  hashtags: [
  ],
  keywords: [
    'web design',
    'WordPress',
  ],
}
export const useCarraighillInfo = () => {
  const CarraighillImages: MjHudsonBridgeImagesQuery = useStaticQuery(graphql`
    query CarraighillImages {
      featuredImage: file(relativePath: {eq: "images/carraighill/carraighill-project-abstract-background.jpg"}) {
        childImageSharp {
          gatsbyImageData(width: 1280, height: 720)
        }
      }
      gallery: allFile(
        sort: {fields: name},
        filter: {
          extension: {regex: "/(jpg)|(jpeg)|(png)/"},
          relativeDirectory: {eq: "images/carraighill/gallery"}
        }
      ) {
        edges {
          node {
            name
            childImageSharp {
              gatsbyImageData(width: 2560, height: 1440)
            }
          }
        }
      }
    }`
  )
  const imageMetaData: Partial<ImageWithMetaInfo>[] = [
    {
      title: "Carraighill Homepage Screenshot",
      alt: "Carraighill Homepage Screenshot, desktop version",
    },
  ]
  const info: ProjectMetaInfoWithQueriedResources = {
    ...ProjectMetaInfoCarraighill,
    featuredImage: {
      image: CarraighillImages.featuredImage!.childImageSharp,
      title: 'Carraighill',
      alt: 'Carraighill Project Abstract Background Image'
    },
    gallery: CarraighillImages.gallery.edges.map((edge, i) => ({
      image: edge.node.childImageSharp?.gatsbyImageData,
      ...imageMetaData[i]
    }))
  }
  return info;
}